import { useState } from "react"
import { useField, useFormikContext } from "formik"
import { FormHelperText, Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faEdit } from "@fortawesome/pro-solid-svg-icons"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { CreateUpdateDeliveryNoteDialog } from "./CreateUpdateDeliveryNoteDialog"
import { MeetingServiceConfig, DynamicConfigKey, MeetingServiceTabValues } from "../../form/formTypes"
import { StandardButton } from "../../../../buttons/StandardButton"
import { findGroupByFieldKey, getFormikFieldError } from "../../form/helpers"

const KEY = DynamicConfigKey.MERCHANT_ORDER_NOTE

type DeliveryNoteProps = Readonly<{
    meetingServiceConfiguration: MeetingServiceConfig
}>

export function DeliveryNote({ meetingServiceConfiguration }: DeliveryNoteProps) {
    const [field, meta, helpers] = useField<string | undefined>(KEY)
    const { submitCount } = useFormikContext<MeetingServiceTabValues>()

    const note: string = typeof field.value === "string" ? field.value : ""

    const [editDeliveryNoteDialog, setEditDeliveryNoteDialog] = useState<boolean>(false)

    const handleViewDeliveryNoteDialog = () => {
        setEditDeliveryNoteDialog((prev) => !prev)
    }
    const handleChangeDeliveryNote = (val: string) => {
        helpers.setValue(val)
    }

    const noteSection = findGroupByFieldKey(meetingServiceConfiguration.sections, KEY)?.fields.find(
        (el) => el.key === KEY,
    )

    const { helperText } = getFormikFieldError(meta, submitCount)

    return (
        <>
            <Stack gap="1rem" justifyContent="space-between" alignItems="center" flexDirection="row">
                {noteSection && <Typography variant="subtitle1">{noteSection.label}</Typography>}
                <LocalizedStrict id={!!note ? "create-order-note-edit-button" : "create-order-note-add-button"}>
                    <StandardButton
                        type="button"
                        color="blue"
                        variant="text"
                        size="small"
                        fullWidth={false}
                        startIcon={<FontAwesomeIcon icon={!!note ? faEdit : faPlus} />}
                        onClick={handleViewDeliveryNoteDialog}
                    >
                        Edit /Add
                    </StandardButton>
                </LocalizedStrict>
            </Stack>
            {helperText && <FormHelperText error>{helperText}</FormHelperText>}
            {!!note && <Typography variant="body2">{note}</Typography>}

            {noteSection && editDeliveryNoteDialog && (
                <CreateUpdateDeliveryNoteDialog
                    open={editDeliveryNoteDialog}
                    onClose={handleViewDeliveryNoteDialog}
                    note={note}
                    handleChangeNote={handleChangeDeliveryNote}
                />
            )}
        </>
    )
}
